<template>
  <div v-if="objDTO !== null">
    <dados-comunicante
      ref="dadosComunicante"
      :comunicante="objDTO.ComunicanteContacto"
      :servico="objDTO.Servico"
      :validation="$v.objDTO"
      @vinculoChange="vinculoSegurado"
    />

    <dados-segurado
      :segurado="objDTO.SeguradoContacto"
      :validation="$v.objDTO.SeguradoContacto"
    />

    <pesquisa-apolice
      :apolice="objDTO.Apolice"
      :sinistro="objDTO.Sinistro"
      :validation="$v.objDTO"
      :seguradoCpf="objDTO.SeguradoContacto.NrContribuinte"
      @selected="policySelected"
    />
  </div>
</template>

<script>
import { AxaRamosInfo, PRODUCT_NAME, swalConfig } from '../utils/constants';
import {
  required,
  email,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators';
import {
  cpfCnpjValid,
  dateAfterToday,
  moreThan2Words,
  inputClean,
  cnpjValid,
} from '../utils/customValidations';
import DadosComunicante from '../components/DadosComunicante.vue';
import DadosSegurado from '../components/DadosSegurado.vue';
import PesquisaApolice from '../components/PesquisaApolice.vue';

import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { getCoverages } from '../api/formMethods';
import { fireVigenciaCoberuraErrorGE } from '../utils/helpers';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);

export default {
  components: {
    DadosComunicante,
    DadosSegurado,
    PesquisaApolice,
  },
  data() {
    return {
      objDTO: null,
    };
  },
  computed: {
    isCnpjValid() {
      return cnpjValid(this.objDTO.SeguradoContacto.NrContribuinte);
    },
  },
  validations() {
    return {
      objDTO: {
        ComunicanteContacto: {
          ParentescoId: {
            required,
          },
        },
        SeguradoContacto: {
          Nome: { required, moreThan2Words, inputClean },
          NrContribuinte: {
            required,
            cpfCnpjValid,
          },
          DataNascimento: {
            requiredIf: requiredIf(() => !this.isCnpjValid),
            dateAfterToday,
          },
          nrID: {
            requiredIf: requiredIf(() => !this.isCnpjValid),
            inputClean,
          },
          Email: { required, email },
          Telemovel: { required, minLength: minLength(11) },
        },
        Sinistro: {
          SinistroData: { required, dateAfterToday },
        },
        Servico: {
          ServicoComplementoPeriodoDiaId: { required },
        },
      },
    };
  },
  async mounted() {
    this.objDTO = this.$store.getters.getObjDTO;
  },
  methods: {
    async policySelected(selectedPolicy) {
      const {
        ApoliceDataFim,
        ApoliceDataInicio,
        ApoliceNr,
        BilheteNr,
        ApoliceEmitidaData,
        ApoliceId,
        GisRamoId,
        GisProdutoId,
        ProductName,
        OperationPK,
        CodLineOfBusiness,
        LineOfBusiness,
        CoverageRestituitionTypeId,
        ServiceLocationId,
        Persons,
        InsuranceObjects,
      } = selectedPolicy;

      // Check if product is available to the app
      const policy = AxaRamosInfo.find((x) => x.id.includes(GisProdutoId));
      //console.log(policy);

      if (policy === undefined) {
        Swal.fire({
          ...swalConfig,
          icon: 'error',
          title: 'Erro',
          text: 'Apólice não suportada.',
        });
        return;
      }

      // Specific to GE
      // Check if coverage date is valid
      // TipoContratacao/TipoAtendimento
      if (policy.name === PRODUCT_NAME.GarantiaEstendida) {
        const coverages = await getCoverages(
          OperationPK,
          InsuranceObjects[0].InsuranceObjectId
        );

        const sinistroData = dayjs(this.objDTO.Sinistro.SinistroData);

        console.log('coverages', coverages);

        const isValid =
          coverages &&
          coverages.length > 0 &&
          coverages.filter(
            (f) =>
              sinistroData.isSameOrAfter(dayjs(f.InitialDate), 'day') &&
              sinistroData.isSameOrBefore(dayjs(f.FinalDate), 'day')
          ).length > 0;

        if (!isValid) {
          fireVigenciaCoberuraErrorGE();
          return;
        }

        // TipoContratacao/TipoAtendimento
        this.objDTO.AtendimentoLocalId = ServiceLocationId;
        this.objDTO.ProcessoGDM.RestituicaoTipoId = CoverageRestituitionTypeId;
      }

      this.objDTO.Apolice.ApoliceNr = ApoliceNr;
      this.objDTO.Sinistro.SinistroBilheteNr = BilheteNr;
      this.objDTO.Apolice.ApoliceDataEmissao = dayjs(
        ApoliceEmitidaData,
        'DD/MM/YYYY'
      );
      this.objDTO.Apolice.ApoliceDataInicio = dayjs(
        ApoliceDataInicio,
        'DD/MM/YYYY'
      );
      this.objDTO.Apolice.ApoliceDataFim = dayjs(ApoliceDataFim, 'DD/MM/YYYY');
      this.objDTO.Apolice.ApoliceProdutoId = GisProdutoId;
      this.objDTO.Apolice.ApoliceContrato = OperationPK;
      this.objDTO.Apolice.ApoliceExternalId = ApoliceId;
      this.objDTO.Sinistro.SinistroRamoId = GisRamoId;
      this.objDTO.Sinistro.SinistroRamoExternal = CodLineOfBusiness.toString().slice(
        0,
        2
      );
      this.objDTO.SeguradoContacto.Obs = ProductName;

      this.objDTO.LinhaDeNegocio = LineOfBusiness;
      //console.log('LineOfBusiness: ' + this.objDTO.LinhaDeNegocio);
      // Persons
      Persons.forEach((person) => {
        if (person.RoleType == 'REPRESENTANTE') {
          this.objDTO.RepresentanteContacto.Nome = person.Name;
          this.objDTO.RepresentanteContacto.NrContribuinte =
            person.DocumentNumber;
          this.objDTO.RepresentanteContacto.Email = person.Email;
        }
        if (person.RoleType == 'POLICYHOLDER') {
          this.objDTO.EstipulanteContacto.Nome = person.Name;
          this.objDTO.EstipulanteContacto.NrContribuinte =
            person.DocumentNumber;
          this.objDTO.EstipulanteContacto.Email = person.Email;
        }
        if (person.RoleType == 'BROKER') {
          this.objDTO.CorretorContacto.Nome = person.Name;
          this.objDTO.CorretorContacto.NrContribuinte = person.DocumentNumber;
          this.objDTO.CorretorContacto.Email = person.Email;
        }
      });

      this.$store.commit('setObjDTO', this.objDTO);

      this.$router.push(policy.url);
    },
    vinculoSegurado(contacto) {
      if (this.objDTO.ComunicanteContacto.ParentescoId == 1) {
        this.objDTO.SeguradoContacto.Nome = contacto.nome;
        this.objDTO.SeguradoContacto.NrContribuinte = contacto.cpf;
        this.objDTO.SeguradoContacto.Email = contacto.email;
        this.objDTO.SeguradoContacto.Telemovel = contacto.telemovel;
      } else {
        this.objDTO.SeguradoContacto.Nome = null;
        this.objDTO.SeguradoContacto.NrContribuinte = null;
        this.objDTO.SeguradoContacto.Email = null;
        this.objDTO.SeguradoContacto.Telemovel = null;
      }
    },
  },
};
</script>
